import {
  AcademicCapIcon,
  BanknotesIcon,
  ReceiptRefundIcon,
  UsersIcon,
  DocumentIcon,
  DocumentChartBarIcon,
  PaperClipIcon,
  HomeIcon,
  UserPlusIcon,
  CalendarDaysIcon,
  BriefcaseIcon,
  AdjustmentsHorizontalIcon,
  SpeakerWaveIcon,
  ClipboardDocumentCheckIcon,
  DocumentDuplicateIcon,
  Cog6ToothIcon,
  ClockIcon,
  ChartBarIcon,
  CalculatorIcon
} from '@heroicons/react/24/outline';

export const menuItems = [
  { name: 'Dashboard', href: '/', icon: HomeIcon, gestione: 'navigazione' },

  {gestione: "areariservata", name: 'I miei cedolini', href: '/areariservata/cedolini', icon: DocumentIcon},
  {gestione: "areariservata", name: 'Le mie CU', href: '/areariservata/cu', icon: DocumentChartBarIcon},
  {gestione: "areariservata", name: 'I miei Documenti', href: '/areariservata/documenti', icon: PaperClipIcon},
  {gestione: "areariservata", name: 'I miei turni', href: '/areariservata/turni', icon: ClipboardDocumentCheckIcon},
  {gestione: "areariservata", name: 'Le mie timbrature', href: '/areariservata/timbrature', icon: ClockIcon},
  {gestione: "areariservata", name: 'Giustificativi', href: '/areariservata/richiesta', icon: ReceiptRefundIcon},
  {gestione: "areariservata", name: 'Rimborso Spese', href: '/areariservata/rimborso_spese', icon: BanknotesIcon},
  {gestione: "areariservata", name: 'I miei Avvisi', href: '/areariservata/avvisi', icon: SpeakerWaveIcon},

  { gestione: "gestione-base", name: 'Unità Organizzative', href: '/organization', icon: AcademicCapIcon },
  { gestione: "gestione-base", name: 'Lista Dipendenti', href: '/dipendenti', icon: UsersIcon },
  { gestione: "gestione-base", name: 'Aggiungi Dipendente', href: '/nuovo_dipendente', icon: UserPlusIcon },
  { gestione: "gestione-base", name: 'Buste Paga', href: '/buste', icon: DocumentIcon },
  { gestione: "gestione-base", name: 'Certificazioni Uniche', href: '/cu', icon: DocumentChartBarIcon },
  { gestione: "gestione-base", name: 'Documenti', href: '/documenti', icon: PaperClipIcon },
  
  // LINK EMPLOYEE MANAGER
  // { gestione: "gestione-presenze", name: 'Dashboard Presenze', href: '/presence', icon: CalendarIcon },
  { gestione: "gestione-presenze", name: 'Gestione Turni', href: '/shift_management', icon: Cog6ToothIcon },
  { gestione: "gestione-presenze", name: 'Assegna Turni', href: '/assign_working_hour', icon: BriefcaseIcon },
  { gestione: "gestione-presenze", name: 'Calendario Presenze', href: '/shift_calendar', icon: CalendarDaysIcon },
  { gestione: "gestione-presenze", name: 'Timbrature', href: '/in_outs', icon: ClockIcon },
  { gestione: "gestione-presenze", name: 'Richieste Giustificativi da Gestire', href: '/pending_justifications', icon: DocumentDuplicateIcon },
  { gestione: "gestione-presenze", name: 'Richieste Giustificativi Elaborate', href: '/handled_justifications', icon: ClipboardDocumentCheckIcon },
  { gestione: "gestione-presenze", name: 'Rimborsi Spese', href: '/refund_requests', icon: BanknotesIcon },
  { gestione: "gestione-presenze", name: 'Avvisi', href: '/notice_board', icon: SpeakerWaveIcon },
  { gestione: "gestione-presenze", name: 'Statistiche', href: '/statistiche', icon: ChartBarIcon },

  { gestione: "areariservataGestione", name: 'Avvisi', href: '/notice_board', icon: SpeakerWaveIcon },
  { gestione: "areariservataGestione", name: 'Configurazione Parametri', href: '/settings_ratei', icon: AdjustmentsHorizontalIcon },
  { gestione: "areariservataGestione", name: 'Unità Organizzative', href: '/organization', icon: AcademicCapIcon },

  // LINK AZIENDA
  { gestione: "presenze", name: 'Configurazione Parametri', href: '/settings_ratei', icon: AdjustmentsHorizontalIcon },
  { gestione: "presenze", name: 'Unità Organizzative', href: '/organization', icon: AcademicCapIcon },
  { gestione: "presenze", name: 'Gestione Turni', href: '/shift_management', icon: Cog6ToothIcon },
  { gestione: "presenze", name: 'Assegna Turni', href: '/assign_working_hour', icon: BriefcaseIcon },
  { gestione: "presenze", name: 'Calendario Presenze', href: '/shift_calendar', icon: CalendarDaysIcon },
  { gestione: "presenze", name: 'Timbrature', href: '/in_outs', icon: ClockIcon },
  { gestione: "presenze", name: 'Richieste Giustificativi da Gestire', href: '/pending_justifications', icon: DocumentDuplicateIcon },
  { gestione: "presenze", name: 'Richieste Giustificativi Elaborate', href: '/handled_justifications', icon: ClipboardDocumentCheckIcon },
  { gestione: "presenze", name: 'Rimborsi Spese', href: '/refund_requests', icon: BanknotesIcon },
  { gestione: "presenze", name: 'Avvisi', href: '/notice_board', icon: SpeakerWaveIcon },
  { gestione: "presenze", name: 'Statistiche', href: '/statistiche', icon: ChartBarIcon },

  {
    gestione: "strumenti",  name: 'Calcolo Costo del Lavoro', href: '/calcolo_costo_lavoro', icon: CalculatorIcon,
  },

  {
    icon: DocumentIcon,
    name: 'Buste Paga',
    href: '/buste',
    iconForeground: 'text-indigo-800',
    iconBackground: 'bg-indigo-200',
    tourClass: 'tourBuste',
    isRapid: true,
    isEmployee: true,
    gestione: 'documenti'
  },
  {
    icon: DocumentChartBarIcon,
    name: 'Certificazioni Uniche',
    href: '/cu',
    iconForeground: 'text-indigo-800',
    iconBackground: 'bg-indigo-200',
    tourClass: 'tourCu',
    isRapid: true,
    isEmployee: true,
    gestione: 'documenti'
  },
  {
    icon: PaperClipIcon,
    name: 'Documenti',
    href: '/documenti',
    iconForeground: 'text-indigo-800',
    iconBackground: 'bg-indigo-200',
    tourClass: 'tourDocumenti',
    isRapid: true,
    isEmployee: true,
    gestione: 'documenti'
  },
  {
    icon: UsersIcon,
    name: 'Lista Dipendenti',
    href: '/dipendenti',
    iconForeground: 'text-indigo-800',
    iconBackground: 'bg-indigo-200',
    tourClass: 'tourListaDip',
    isRapid: true,
    gestione: 'dipendenti'
  },
  {
    // 
    icon: UserPlusIcon,
    name: 'Aggiungi Dipendente',
    href: '/nuovo_dipendente',
    iconForeground: 'text-indigo-800',
    iconBackground: 'bg-indigo-200',
    tourClass: 'tourListaDip',
    isRapid: false,
    gestione: 'dipendenti'
  }
]